import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";
import { getCurrentUtc } from "../../utils/utils";

export const postSavePayment = async (data) => {
  try {
    let link = `/lambda/v1/save-payment`;
    const response = await axios.post(link, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postSaveItemsPayment = async (data) => {
  try {
    let link = `/lambda/v1/save-items-payment`;
    const response = await axios.post(link, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updatePayment = async (data) => {
  try {
    let link = `/lambda/v1/update-payment`;
    const response = await axios.put(link, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailPayment = async (id) => {
  try {
    let link = `/lambda/v1/payment/${id}`;
    const response = await axios.get(link);
    return response;
  } catch (error) {
    return error;
  }
};

export const getHistoryPayment = async ({
  page = 1,
  size = PER_PAGE_SIZE,
  from,
  to,
  method,
  category_item_id,
  doctor_id,
  busines_id,
  paymentType = null,
  current_utc = +7,
  created_by_id = null,
}) => {
  try {
    let link = `/lambda/v1/history-payment-item?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    link = link.concat("&from=" + from);
    link = link.concat("&to=" + to);
    if (method) link = link.concat("&method=" + method);
    if (category_item_id)
      link = link.concat("&category_item_id=" + category_item_id);
    if (doctor_id) link = link.concat("&doctor_id=" + doctor_id);
    if (busines_id) link = link.concat("&busines_id=" + busines_id);
    if (paymentType) link = link.concat("&paymentType=" + paymentType);
    if (current_utc) link = link.concat("&current_utc=" + current_utc);
    if (created_by_id) link = link.concat("&created_by_id=" + created_by_id);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const exportHistoryPayment = async ({
  from,
  to,
  method,
  category_item_id,
  doctor_id,
  busines_id,
  current_utc = +7,
  is_marketing = false,
  created_by_id = null,
  format = null,
}) => {
  try {
    let link = `/lambda/v1/export-payment-item?`;
    link = link.concat("from=" + from);
    link = link.concat("&to=" + to);
    if (method) link = link.concat("&method=" + method);
    if (category_item_id)
      link = link.concat("&category_item_id=" + category_item_id);
    if (doctor_id) link = link.concat("&doctor_id=" + doctor_id);
    if (busines_id) link = link.concat("&busines_id=" + busines_id);
    if (current_utc) link = link.concat("&current_utc=" + current_utc);
    if (is_marketing) link = link.concat("&is_marketing=" + is_marketing);
    if (created_by_id) link = link.concat("&created_by_id=" + created_by_id);
    if (format) link = link.concat("&format=" + format);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const exportTopSpender = async ({
  from,
  to,
  busines_id,
  current_utc = +7,
}) => {
  try {
    let link = `/lambda/v1/export-payment-top-spender?`;
    link = link.concat("from=" + from);
    link = link.concat("&to=" + to);
    if (busines_id) link = link.concat("&busines_id=" + busines_id);
    if (current_utc) link = link.concat("&current_utc=" + current_utc);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailVisitPayment = async (visit_id) => {
  try {
    const currentUtc = getCurrentUtc();

    let link = `/lambda/v1/visit-payment-history?`;
    link = link.concat("visit_id=" + visit_id);
    if (currentUtc) link = link.concat("&current_utc=" + currentUtc);

    const response = await axios.get(link);
    return response;
  } catch (error) {
    return error;
  }
};
